import React, { useState } from "react";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { createArticleReaction } from "../../../../store/features/createArticleReaction";
import { getKbGroupId } from "../../../../utils/kbGroupId";

const ArticleReaction = ({ articleId }) => {
    const dispatch = useDispatch();
    const [reaction, setReaction] = useState(() => {
        try {
            const storedReactions = JSON.parse(localStorage.getItem("articleReactions") || "{}");
            return storedReactions[articleId] || null;
        } catch (error) {
            console.error("Error reading reactions from localStorage:", error);
            return null;
        }
    });

    const handleReaction = (type) => {
        if (reaction === type) return;

        setReaction(type);

        try {
            const storedReactions = JSON.parse(localStorage.getItem("articleReactions") || "{}");
            storedReactions[articleId] = type;
            localStorage.setItem("articleReactions", JSON.stringify(storedReactions));
        } catch (error) {
            console.error("Error saving reaction to localStorage:", error);
        }

        if (articleId) {
            dispatch(createArticleReaction({ articleId, type, group_id: getKbGroupId() }));
        }
    };

    const isLike = reaction === "like";
    const isDislike = reaction === "dislike";

    const buttonStyle = {
        width: { xs: "140px", sm: "170px", md: "200px" },
        height: { xs: "48px", md: "60px" },
        borderRadius: "8px",
        border: "1px solid #D5DCE1",
        background: "#FFF",
        boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
    };

    const activeButtonStyle = {
        ...buttonStyle,
        background: "#148DFD",
        border: "1px solid #148DFD",
        color: "#FFF",
    };

    const textStyle = {
        color: "#405261",
        textAlign: "center",
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "normal",
    };

    const activeTextStyle = {
        ...textStyle,
        color: "#FFF",
    };

    const getStroke = (isActive) => (isActive ? "#FFF" : "#0C141B");

    return (

        <Box
            sx={{
                marginTop: { xs: "30px", sm: "40px", md: "60px" },
                marginBottom: { xs: "30px", sm: "40px", md: "60px" },
                display: "flex",
                justifyContent: { xs: "center", sm: "space-between" },
                alignItems: { xs: "flex-start", sm: "center" },
                flexDirection: { xs: "column", sm: "row" },
                flexWrap: "wrap",
                gap: { xs: "16px", md: "20px" },
            }}
        >
            <Box
                sx={{
                    color: "#0C141B",
                    fontFamily: "Inter",
                    fontSize: { xs: "18px", sm: "20px", md: "24px" },
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: { xs: "26px", md: "34px" },
                }}
            >
                Was this article helpful?
            </Box>

            <Box sx={{ display: "flex", gap: "8px" }}>
                <Box
                    onClick={() => handleReaction("like")}
                    sx={isLike ? activeButtonStyle : buttonStyle}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.944 19H5.056C4.473 19 4 18.527 4 17.944V10.556C4 9.973 4.473 9.5 5.056 9.5H6.944C7.527 9.5 8 9.973 8 10.556V17.944C8 18.527 7.527 19 6.944 19V19Z"
                            stroke={getStroke(isLike)}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8 10.5716L11.649 5.82058C12.328 4.93558 13.654 4.91358 14.363 5.77458V5.77458C14.628 6.09558 14.772 6.49958 14.772 6.91558V10.1866H17.868C18.469 10.1866 19.03 10.4866 19.364 10.9856L19.693 11.4766C19.988 11.9176 20.074 12.4666 19.927 12.9756L18.568 17.6976C18.346 18.4686 17.641 18.9996 16.839 18.9996H10.55C10.05 18.9996 9.572 18.7916 9.232 18.4256L8 17.0996"
                            stroke={getStroke(isLike)}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <Box sx={isLike ? activeTextStyle : textStyle}>Good</Box>
                </Box>

                <Box
                    onClick={() => handleReaction("dislike")}
                    sx={isDislike ? activeButtonStyle : buttonStyle}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.944 5H5.056C4.473 5 4 5.473 4 6.056V13.444C4 14.027 4.473 14.5 5.056 14.5H6.944C7.527 14.5 8 14.027 8 13.444V6.056C8 5.473 7.527 5 6.944 5V5Z"
                            stroke={getStroke(isDislike)}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8 13.4284L11.649 18.1794C12.328 19.0644 13.654 19.0864 14.363 18.2254V18.2254C14.628 17.9044 14.772 17.5004 14.772 17.0844V13.8134H17.868C18.469 13.8134 19.03 13.5134 19.364 13.0144L19.693 12.5234C19.988 12.0824 20.074 11.5334 19.927 11.0244L18.568 6.30242C18.346 5.53142 17.641 5.00042 16.839 5.00042H10.55C10.05 5.00042 9.572 5.20842 9.232 5.57442L8 6.90042"
                            stroke={getStroke(isDislike)}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <Box sx={isDislike ? activeTextStyle : textStyle}>Bad</Box>
                </Box>
            </Box>
        </Box>
    );
};

export default ArticleReaction;
